import { Component, ViewChild, OnInit } from '@angular/core';
import { ImageCropperComponent, CropperSettings, Bounds } from 'ng2-img-cropper';
import { CartService } from '../commons/cart.service';
import { SessionService } from '../commons/session.service';
import { ConfigService } from '../commons/config.service';
import { Router } from '@angular/router';
import { UtilitiesService } from '../commons/utilities.service';

@Component({
  selector: 'my-app',
  template: require('./pagecrop.component.html')
})

export class PageCropComponent implements OnInit {
  name: string;
  data1: any;
  cropperSettings1: CropperSettings;

  public image = new Image();
  public visibleLoader: boolean = false;

  @ViewChild('cropper', undefined) cropper: ImageCropperComponent;



  ngOnInit() {

    let loader = document.getElementById('loader');
    //console.log(loader);
    if (loader) {
      loader.style.display = 'block';
    }

    if (!this.cartService.cart.currentCartProduct.photoOriginal) {
      //console.log('no photoOriginal - redirect upload-photo');
      this.router.navigate(['/upload-photo']);
    }

    // ridimensiono il canvas in proporzione
    let WidthClientCanvas = 740 - 8;
    let HeightClientCanvas = 410 - 8;
    let ImgCropper = document.getElementsByClassName('slide')[0];
    if (ImgCropper) {
      WidthClientCanvas = Number(ImgCropper.clientWidth.toFixed(0)); // 840;
      HeightClientCanvas = Number(ImgCropper.clientHeight.toFixed(0)); // 514;
      //console.log('ImgCropper ngAfterViewInit : ' + WidthClientCanvas + ' - ' + HeightClientCanvas);
    }

    this.LoadImage();
  }


  constructor(
    private config: ConfigService,
    public cartService: CartService,
    public session: SessionService,
    private router: Router,
    private utilities: UtilitiesService,
  ) {
    this.name = 'Angular2';
    this.cropperSettings1 = new CropperSettings();

    this.cropperSettings1.noFileInput = true;

    this.cropperSettings1.rounded = this.cartService.cart.currentCartProduct.rounded;
    if (this.cartService.cart.currentCartProduct.rounded) {
      this.session.cropHeight = this.session.cropWidth;
    }


    this.cropperSettings1.width = this.session.cropWidth;
    this.cropperSettings1.height = this.session.cropHeight;

    this.cropperSettings1.croppedWidth = Number((this.session.cropWidth * this.config.RappRisoluzMin).toFixed(0));
    this.cropperSettings1.croppedHeight = Number((this.session.cropHeight * this.config.RappRisoluzMin).toFixed(0));

    // ridimensiono il canvas in proporzione
    let WidthClientCanvas = 740 - 8;
    let HeightClientCanvas = 410 - 8;

    let rappRiduction = this.cartService.cart.currentCartProduct.naturalWidth / WidthClientCanvas;
    if (this.cartService.cart.currentCartProduct.naturalHeight > this.cartService.cart.currentCartProduct.naturalWidth
      || this.cartService.cart.currentCartProduct.naturalHeight / rappRiduction > HeightClientCanvas) {
      rappRiduction = this.cartService.cart.currentCartProduct.naturalHeight / HeightClientCanvas;
    }

    this.cropperSettings1.canvasWidth = this.cartService.cart.currentCartProduct.naturalWidth / rappRiduction;
    this.cropperSettings1.canvasHeight = this.cartService.cart.currentCartProduct.naturalHeight / rappRiduction;

    this.cropperSettings1.minWidth = this.cropperSettings1.croppedWidth;
    this.cropperSettings1.minHeight = this.cropperSettings1.croppedHeight;

    this.cropperSettings1.cropperDrawSettings.strokeColor = 'rgba(255,255,255,1)';
    this.cropperSettings1.cropperDrawSettings.strokeWidth = 1;

    //this.cropperSettings1.preserveSize = true;

    this.data1 = {};
  }


  public LoadImage() {
    this.visibleLoader = true;

    if (this.cartService) {
      //console.log(this.cartService);
      if (this.cartService.cart.currentCartProduct.photoOriginal) {

        this.image.crossOrigin = 'Anonymous';
        this.image.src = this.cartService.cart.currentCartProduct.photoOriginal; // this.cartService.cart.photoBase64;
        this.image.height = this.image.naturalHeight;
        this.image.width = this.image.naturalWidth;

        //console.log(this.image.complete);

        let that = this;
        setTimeout(() => {
          if (that.image.complete) {
            //console.log('this.cropper.setImage(image)');
            that.cropper.setImage(that.image);
            that.visibleLoader = false;
          } else {
            that.LoadImage();
          }
        }, 1500);
      }
    }
  }



  cropped(bounds: Bounds) {
    //console.log('cropped' + this.data1);

    if (this.data1.image) {
      //console.log('photoResized OK');
    } else {
      this.cartService.cart.currentCartProduct.photoResized = null;
    }

    let boundsJSON = {
      top: bounds.top,
      right: bounds.right,
      left: bounds.left,
      width: bounds.width,
      height: bounds.height,
    };
    //console.log(boundsJSON);
    this.cartService.cart.currentCartProduct.photoBounds = boundsJSON;
    this.cartService.saveCart();
  }


  confirmCropped() {

    this.visibleLoader = true;

    let body = {
      photoID: this.cartService.cart.currentCartProduct.photoID,
      photoBounds: this.cartService.cart.currentCartProduct.photoBounds,
      widthFormatoSel: this.session.cropWidth
    };
    //console.log(body);

    this.utilities.requestAngular2('cropimage', body).subscribe(
      result => {
        //console.log(result);
        let urlImgCropped = this.config.urlHost + '/files/cropped/'
          + this.cartService.cart.currentCartProduct.photoID + '-cropped_web.jpg';
        //console.log(urlImgCropped);
        if (result && result.result === 'ok') {
          // this.cartService.cart.currentCartProduct.photoResized = result.fileNameCroppedWeb   // RESTITUISCE IL PATH NON L'URL
          this.cartService.cart.currentCartProduct.photoResized = urlImgCropped
            + '?v=' + new Date().toLocaleTimeString().replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, '-');
          this.cartService.saveCart();

          this.visibleLoader = false;

          this.router.navigate(['/preview']);
        } else {
          this.cartService.cart.currentCartProduct.photoResized = null;
          this.visibleLoader = false;
        }
      },
      error => {
        console.error(error);
        this.visibleLoader = false;
      }
    );



  }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/pagecrop.component.ts